function _instanceof(left, right) {
  return null != right && "undefined" != typeof Symbol && right[Symbol.hasInstance] ? right[Symbol.hasInstance](left) : left instanceof right;
}

function _typeof(obj) {
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!_instanceof(instance, Constructor)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn(self, call) {
  return call && ("object" === _typeof(call) || "function" == typeof call) ? call : _assertThisInitialized(self);
}

function _defineProperties(target, props) {
  for (var descriptor, i = 0; i < props.length; i++) {
    descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), Constructor;
}

function _inherits(subClass, superClass) {
  if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: !0,
      configurable: !0
    }
  }), superClass && _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  return _setPrototypeOf = Object.setPrototypeOf || function (o, p) {
    return o.__proto__ = p, o;
  }, _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return self;
}

import { PureComponent, createElement } from "react";
import PropTypes from "prop-types";
import { setDiffStyle } from "../utils/style-utils";
import isImmutableMap from "../utils/is-immutable-map";
import WebMercatorViewport from "viewport-mercator-project";
import Mapbox from "../mapbox/mapbox";
import isBrowser from "../utils/is-browser";
import { checkVisibilityConstraints } from "../utils/map-constraints";
var mapboxgl = isBrowser ? require("mapbox-gl") : null,
    TOKEN_DOC_URL = "https://uber.github.io/react-map-gl/#/Documentation/getting-started/about-mapbox-tokens",
    NO_TOKEN_WARNING = "A valid API access token is required to use Mapbox data";

function noop() {}

var UNAUTHORIZED_ERROR_CODE = 401,
    propTypes = Object.assign({}, Mapbox.propTypes, {
  mapStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  preventStyleDiffing: PropTypes.bool,
  disableTokenWarning: PropTypes.bool,
  visible: PropTypes.bool,
  visibilityConstraints: PropTypes.object
}),
    defaultProps = Object.assign({}, Mapbox.defaultProps, {
  mapStyle: "mapbox://styles/mapbox/light-v8",
  preventStyleDiffing: !1,
  visible: !0
}),
    childContextTypes = {
  viewport: PropTypes.instanceOf(WebMercatorViewport)
},
    StaticMap = function (_PureComponent) {
  function StaticMap(props) {
    var _this;

    return _classCallCheck(this, StaticMap), _this = _possibleConstructorReturn(this, (StaticMap.__proto__ || Object.getPrototypeOf(StaticMap)).call(this, props)), _this._queryParams = {}, StaticMap.supported() || (_this.componentDidMount = noop, _this.componentWillReceiveProps = noop, _this.componentDidUpdate = noop, _this.componentWillUnmount = noop), _this.state = {
      accessTokenInvalid: !1
    }, _this.getMap = _this.getMap.bind(_assertThisInitialized(_this)), _this.queryRenderedFeatures = _this.queryRenderedFeatures.bind(_assertThisInitialized(_this)), _this._updateMapSize = _this._updateMapSize.bind(_assertThisInitialized(_this)), _this._updateMapStyle = _this._updateMapStyle.bind(_assertThisInitialized(_this)), _this._mapboxMapLoaded = _this._mapboxMapLoaded.bind(_assertThisInitialized(_this)), _this._mapboxMapError = _this._mapboxMapError.bind(_assertThisInitialized(_this)), _this._renderNoTokenWarning = _this._renderNoTokenWarning.bind(_assertThisInitialized(_this)), _this;
  }

  return _inherits(StaticMap, _PureComponent), _createClass(StaticMap, null, [{
    key: "supported",
    value: function supported() {
      return mapboxgl && mapboxgl.supported();
    }
  }]), _createClass(StaticMap, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        viewport: new WebMercatorViewport(this.props)
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var mapStyle = this.props.mapStyle;
      this._mapbox = new Mapbox(Object.assign({}, this.props, {
        mapboxgl: mapboxgl,
        container: this._mapboxMap,
        onError: this._mapboxMapError,
        mapStyle: isImmutableMap(mapStyle) ? mapStyle.toJS() : mapStyle
      })), this._map = this._mapbox.getMap();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      this._mapbox.setProps(newProps), this._updateMapStyle(this.props, newProps), this.setState({
        width: this.props.width,
        height: this.props.height
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._updateMapSize(this.state, this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._mapbox.finalize(), this._mapbox = null, this._map = null;
    }
  }, {
    key: "getMap",
    value: function getMap() {
      return this._map;
    }
  }, {
    key: "queryRenderedFeatures",
    value: function queryRenderedFeatures(geometry) {
      var options = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
      return this._map.queryRenderedFeatures(geometry, options);
    }
  }, {
    key: "_updateMapSize",
    value: function _updateMapSize(oldProps, newProps) {
      var sizeChanged = oldProps.width !== newProps.width || oldProps.height !== newProps.height;
      sizeChanged && this._map.resize();
    }
  }, {
    key: "_updateMapStyle",
    value: function _updateMapStyle(oldProps, newProps) {
      var mapStyle = newProps.mapStyle,
          oldMapStyle = oldProps.mapStyle;
      mapStyle !== oldMapStyle && (isImmutableMap(mapStyle) ? this.props.preventStyleDiffing ? this._map.setStyle(mapStyle.toJS()) : setDiffStyle(oldMapStyle, mapStyle, this._map) : this._map.setStyle(mapStyle));
    }
  }, {
    key: "_mapboxMapLoaded",
    value: function _mapboxMapLoaded(ref) {
      this._mapboxMap = ref;
    }
  }, {
    key: "_mapboxMapError",
    value: function _mapboxMapError(evt) {
      var statusCode = evt.error && evt.error.status || evt.status;
      statusCode !== UNAUTHORIZED_ERROR_CODE || this.state.accessTokenInvalid || (console.error(NO_TOKEN_WARNING), this.setState({
        accessTokenInvalid: !0
      }));
    }
  }, {
    key: "_renderNoTokenWarning",
    value: function _renderNoTokenWarning() {
      if (this.state.accessTokenInvalid && !this.props.disableTokenWarning) {
        return createElement("div", {
          key: "warning",
          id: "no-token-warning",
          style: {
            position: "absolute",
            left: 0,
            top: 0
          }
        }, [createElement("h3", {
          key: "header"
        }, NO_TOKEN_WARNING), createElement("div", {
          key: "text"
        }, "For information on setting up your basemap, read"), createElement("a", {
          key: "link",
          href: TOKEN_DOC_URL
        }, "Note on Map Tokens")]);
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          width = _this$props.width,
          height = _this$props.height,
          style = _this$props.style,
          visibilityConstraints = _this$props.visibilityConstraints,
          mapContainerStyle = Object.assign({}, style, {
        width: width,
        height: height,
        position: "relative"
      }),
          visible = this.props.visible && checkVisibilityConstraints(this.props.viewState || this.props, visibilityConstraints),
          mapStyle = Object.assign({}, style, {
        width: width,
        height: height,
        visibility: visible ? "visible" : "hidden"
      });
      return createElement("div", {
        key: "map-container",
        style: mapContainerStyle,
        children: [createElement("div", {
          key: "map-mapbox",
          ref: this._mapboxMapLoaded,
          style: mapStyle,
          className: className
        }), createElement("div", {
          key: "map-overlays",
          className: "overlays",
          style: {
            position: "absolute",
            left: 0,
            top: 0,
            width: width,
            height: height,
            overflow: "hidden"
          },
          children: this.props.children
        }), this._renderNoTokenWarning()]
      });
    }
  }]), StaticMap;
}(PureComponent);

export { StaticMap as default };
StaticMap.displayName = "StaticMap", StaticMap.propTypes = propTypes, StaticMap.defaultProps = defaultProps, StaticMap.childContextTypes = childContextTypes;